import { useEffect } from "react";
import { useState } from "react";
import { Fade, Flip } from "react-reveal";
import "./Features.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Features = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const [virtualAccounts, setVirtualAccounts] = useState(true);
  const [organisation, setOrganisation] = useState(false);
  const [refunds, setRefunds] = useState(false);
  const [payouts, setPayouts] = useState(false);

  useEffect(() => {
    const Interval = setInterval(() => {
      if (virtualAccounts) {
        organisationActive();
      }

      if (organisation) {
        payoutsActive();
      }
      // if (refunds) {
      //   payoutsActive();
      // }
      if (payouts) {
        virtualAccountsActive();
      }
    }, 600011111);
    return () => {
      // clearInterval(setIntervalOne)
      // clearInterval(setIntervalTwo)
      clearInterval(Interval);
    };
  }, [virtualAccounts, organisation, refunds, payouts]);

  const virtualAccountsActive = () => {
    setVirtualAccounts(true);
    setOrganisation(false);
    setRefunds(false);
    setPayouts(false);
  };

  const organisationActive = () => {
    setVirtualAccounts(false);
    setOrganisation(true);
    setRefunds(false);
    setPayouts(false);
  };

  const refundsActive = () => {
    setVirtualAccounts(false);
    setOrganisation(false);
    setRefunds(true);
    setPayouts(false);
  };

  const payoutsActive = () => {
    setVirtualAccounts(false);
    setOrganisation(false);
    setRefunds(false);
    setPayouts(true);
  };

  return (
    <div className="features-container">
      <div className="features-mainText">Features built for you</div>
      <div className="features-subText">
        A system that supports customer retention, increased sales, and
        connectivity
      </div>

      <div className="features">
        <div className="features-selectors">
          <div className="virtualAccounts-container noSelect">
            <div
              className="virtualAccounts-line"
              style={{
                backgroundColor: virtualAccounts
                  ? "var(--primary-color)"
                  : "transparent",
              }}
            ></div>
            <div className="virtualAccounts" onClick={virtualAccountsActive}>
              <div
                className="virtualAccounts-mainText"
                style={{
                  color: virtualAccounts
                    ? "var(--primary-color)"
                    : "var(--default-links",
                }}
              >
                Virtual Accounts
              </div>
              <div
                className="virtualAccounts-subText"
                style={{ color: virtualAccounts ? "var(--black" : "#c4c4c4" }}
              >
                Your business will be given an account number to share with customers where you can receive instant payments
              </div>
            </div>
          </div>

          <div className="organisation-container noSelect">
            <div
              className="organisation-line"
              style={{
                backgroundColor: organisation
                  ? "var(--primary-color)"
                  : "transparent",
              }}
            ></div>
            <div className="organisation" onClick={organisationActive}>
              <div
                className="organisation-mainText"
                style={{
                  color: organisation
                    ? "var(--primary-color)"
                    : "var(--default-links",
                }}
              >
                Organisation
              </div>
              <div
                className="organisation-subText"
                style={{ color: organisation ? "var(--black" : "#c4c4c4" }}
              >
                Create outlets and assign managers to them. Cashiers will also be able to verify transfers without having as much access as you have
              </div>
            </div>
          </div>

          {/* REFUNDS SELECTOR AND IMAGE */}

          {/* <div className="refunds-container noSelect">
            <div
              className="refunds-line"
              style={{
                backgroundColor: refunds
                  ? "var(--primary-color)"
                  : "transparent",
              }}
            ></div>

            <div className="refunds" onClick={refundsActive}>
              <div
                className="refunds-mainText"
                style={{
                  color: refunds
                    ? "var(--primary-color)"
                    : "var(--default-links",
                }}
              >
                Refunds
              </div>
              <div
                className="refunds-subText"
                style={{ color: refunds ? "var(--black" : "#c4c4c4" }}
              >
                Easily settle disputes with customers. Just select the customer
                to be refunded, input the amount, and refund
              </div>
            </div>
            <div
              className="refunds-mobile-line"
              style={{
                backgroundColor: refunds
                  ? "var(--primary-color)"
                  : "transparent",
              }}
            ></div>
          </div> */}

          <div className="payouts-container noSelect">
            <div
              className="payouts-line"
              style={{
                backgroundColor: payouts
                  ? "var(--primary-color)"
                  : "transparent",
              }}
            ></div>

            <div className="payouts" onClick={payoutsActive}>
              <div
                className="payouts-mainText"
                style={{
                  color: payouts
                    ? "var(--primary-color)"
                    : "var(--default-links",
                }}
              >
                Instant Payouts
              </div>
              <div
                className="payouts-subText"
                style={{ color: payouts ? "var(--black" : "#c4c4c4" }}
              >
                Your preferred account is settled as soon as funds appear on your dashboard
              </div>
            </div>
          </div>
        </div>
        <div className="features-showing">
          {virtualAccounts && (
            <div className="virtualAccountsimg">
              <Fade duration={300}>
                <img src="/assets/virtualAccounts.svg" />
              </Fade>
            </div>
          )}
          {organisation && (
            <div className="organisationimg">
              <Fade duration={300}>
                <img src="/assets/organisation.svg" />
              </Fade>
            </div>
          )}
          {refunds && (
            <div className="refundsimg">
              <Fade duration={300}>
                <img src="/assets/refunds.svg" />
              </Fade>
            </div>
          )}

          {payouts && (
            <div className="payoutsimg">
              <Fade duration={300}>
                <img src="/assets/payouts.svg" />
              </Fade>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Features;
